import { createAction, createReducer } from '@reduxjs/toolkit';

import postAnnShipBuyShipment from '../../../thunks/shipment/annShip/postAnnShipBuyShipment';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

export const postAnnShipShipmentClearState = createAction('postAnnShipShipmentClearState');

const postAnnShipBuyShipmentReducer = createReducer(initialState, {
  [postAnnShipBuyShipment.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [postAnnShipBuyShipment.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [postAnnShipBuyShipment.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: undefined
  }),
  [postAnnShipShipmentClearState]: () => initialState,

});

export default postAnnShipBuyShipmentReducer;
